<ndt-department-register-view
   [departmentPrivileges]="departmentPrivileges$ | async"
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [isLoading]="isLoading$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   (create)="onCreate()"
   [columns]="columns"
   (quickFilterChange)="onQuickFilterChange($event)"
   (loadMore)="onLoadMore()"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   (selectedId)="handleSelectedId($event)"
   (renameDepartment)="onDepartmentRename($event)"
   (mergeDepartment)="onDepartmentMerge($event)"
   (untagDepartment)="onDepartmentUntag($event)"
   (deactivateDepartment)="onDepartmentDeactivate($event)"
   (deleteDepartment)="onDepartmentDelete($event)"
>
</ndt-department-register-view>
